var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{staticClass:"base-card pa-0 listing-header d-none d-md-flex",attrs:{"no-gutters":""}},_vm._l((_vm.table_headers),function(header,index){return _c('v-col',{key:index,staticClass:"px-4 py-5 head-col"},[_c('p',{staticClass:"mb-0 base-body-text font-weight-bold"},[_vm._v(" "+_vm._s(header.title)+" ")])])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }